module.exports = "<da-map-tooltip [color]=\"topBorderColor\">\n  <div class=\"card-block market-tooltip-block\">\n    <div class=\"market-tooltip-text\">\n      <div class=\"tooltip-title\">{{data.name}}</div>\n    </div>\n  </div>\n</da-map-tooltip>\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/features/market/components/map/market-tooltip.component.html
// module id = ./src/app/features/market/components/map/market-tooltip.component.html
// module chunks = main